var map = {
	"./Bugs_1.png": 5566,
	"./Pineapple.png": 8598,
	"./Vis_1.png": 3632,
	"./Vis_2.png": 4617,
	"./Vis_3.png": 7564,
	"./XAI_1.png": 7634,
	"./XAI_2.png": 4571,
	"./XAI_3.png": 4747,
	"./bolte.png": 2986
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 425;